import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";

const Main = styled(Box)`
  width: 100vw;
  height: 100vh;
`;

export default function PageNotFound() {
  return (
    <Main
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
      flexDirection={"column"}
    >
      <Typography>{"404"}</Typography>
      <Typography>{"Página no encontrada"}</Typography>
    </Main>
  );
}
